export const blinds = [
  {
    common: 35,
    actual: 34.5,
    lengths: [
      {
        length: 48,
        price: 43.98,
        url: 'https://www.lowes.com/pd/LEVOLOR-Trim-Go-2-in-Cordless-White-Faux-Wood-Room-Darkening-Blinds-Common-35-in-Actual-34-5-in-x-48-in/1000576237'
      },
      {
        length: 64,
        price: 48.98,
        url: 'https://www.lowes.com/pd/LEVOLOR-Trim-Go-2-in-Cordless-White-Faux-Wood-Room-Darkening-Blinds-Common-35-in-Actual-34-5-in-x-64-in/1000576741'
      },
      {
        length: 72,
        price: 54.98,
        url: 'https://www.lowes.com/pd/LEVOLOR-Trim-Go-2-in-Cordless-White-Faux-Wood-Room-Darkening-Blinds-Common-35-in-Actual-34-5-in-x-72-in/1000576765'
      }
    ]
  },
  {
    common: 34,
    actual: 33.5,
    lengths:
      [
        {
          length: 64,
          price: 47.98,
          url: 'https://www.lowes.com/pd/LEVOLOR-Trim-Go-2-in-Cordless-White-Faux-Wood-Room-Darkening-Blinds-Common-34-in-Actual-33-5-in-x-64-in/1000576739'
        },
        {
          length: 48,
          price: 43.98,
          url: 'https://www.lowes.com/pd/LEVOLOR-LEV-2-IN-35X48-WHITE-FW-BLIND/1002832224'
        },
        {
          length: 72,
          price: 54.98,
          url: 'https://www.lowes.com/pd/LEVOLOR-Cut-to-33-5-in/1002832068'
        }
      ]
  },
  {
    common: 72,
    actual: 71.5,
    lengths:
      [
        {
          length: 64,
          price: 109.00,
          url: 'https://www.lowes.com/pd/LEVOLOR-Trim-Go-2-in-Cordless-White-Faux-Wood-Room-Darkening-Blinds-Common-72-in-Actual-71-5-in-x-64-in/1000576761'
        },
        {
          length: 72,
          price: 117.00,
          url: 'https://www.lowes.com/pd/LEVOLOR-Trim-Go-2-in-Cordless-White-Faux-Wood-Room-Darkening-Blinds-Common-72-in-Actual-71-5-in-x-72-in/1000576769'
        }
      ]
  },
  {
    common: 31,
    actual: 30.5,
    lengths:
      [
        {
          length: 64,
          price: 44.98,
          url: 'https://www.lowes.com/pd/LEVOLOR-Trim-Go-2-in-Cordless-White-Faux-Wood-Room-Darkening-Blinds-Common-31-in-Actual-30-5-in-x-64-in/1000576737'
        },
        {
          length: 48,
          price: 43.98,
          url: 'https://www.lowes.com/pd/LEVOLOR-LEV-2-IN-35X48-WHITE-FW-BLIND/1002832188'
        },
        {
          length: 72,
          price: 52.98,
          url: 'https://www.lowes.com/pd/LEVOLOR-Trim-Go-2-in-Cordless-White-Faux-Wood-Room-Darkening-Blinds-Common-31-in-Actual-30-5-in-x-72-in/1001461642'
        }
      ]
  },
  {
    common: 36,
    actual: 35.5,
    lengths:
      [
        {
          length: 64,
          price: 49.98,
          url: 'https://www.lowes.com/pd/LEVOLOR-Trim-Go-2-in-Cordless-White-Faux-Wood-Room-Darkening-Blinds-Common-36-in-Actual-35-5-in-x-64-in/1000576743'
        },
        {
          length: 72,
          price: 56.98,
          url: 'https://www.lowes.com/pd/LEVOLOR-Trim-Go-2-in-Cordless-White-Faux-Wood-Room-Darkening-Blinds-Common-36-in-Actual-35-5-in-x-72-in/1000576767'
        }
      ]
  },
  {
    common: 39,
    actual: 38.5,
    lengths:
      [
        {
          length: 64,
          price: 57.98,
          url: 'https://www.lowes.com/pd/LEVOLOR-Trim-Go-2-in-Cordless-White-Faux-Wood-Room-Darkening-Blinds-Common-39-in-Actual-38-5-in-x-64-in/1000576745'
        },
        {
          length: 72,
          price: 79.98,
          url: 'https://www.lowes.com/pd/LEVOLOR-Trim-Go-2-in-Cordless-White-Faux-Wood-Room-Darkening-Faux-Wood-Blinds-Common-38-5-in-Actual-38-5-in-x-72-in/1002830188'
        }
      ]
  },
  {
    common: 47,
    actual: 46.5,
    lengths:
      [
        {
          length: 48,
          price: 55.98,
          url: 'https://www.lowes.com/pd/LEVOLOR-Trim-Go-2-in-Cordless-White-Faux-Wood-Room-Darkening-Blinds-Common-47-in-Actual-46-5-in-x-48-in/1000576239'
        },
        {
          length: 64,
          price: 69.98,
          url: 'https://www.lowes.com/pd/LEVOLOR-Trim-Go-2-in-Cordless-White-Faux-Wood-Room-Darkening-Blinds-Common-47-in-Actual-46-5-in-x-64-in/1000576749'
        },
        {
        length: 72,
        price: 82.98,
        url: 'https://www.lowes.com/pd/LEVOLOR-LEV-2-IN-48X72-WHITE-FW-BLIND/1002830438'
        }
      ]
  },
  {
    common: 52,
    actual: 51.5,
    lengths:
      [
        {
          length: 64,
          price: 79.98,
          url: 'https://www.lowes.com/pd/LEVOLOR-Trim-Go-2-in-Cordless-White-Faux-Wood-Room-Darkening-Blinds-Common-52-in-Actual-51-5-in-x-64-in/1000576751'
        }
      ]
  },
  {
    common: 27,
    actual: 26.5,
    lengths:
      [
        {
          length: 64,
          price: 39.98,
          url: 'https://www.lowes.com/pd/LEVOLOR-Trim-Go-2-in-Cordless-White-Faux-Wood-Room-Darkening-Blinds-Common-27-in-Actual-26-5-in-x-64-in/1000576735'
        },
        {
          length: 72,
          price: 48.98,
          url: 'https://www.lowes.com/pd/LEVOLOR-Trim-Go-2-in-Cordless-White-Faux-Wood-Room-Darkening-Blinds-Common-27-in-Actual-26-5-in-x-72-in/1001461630'
        },
      ]
  },
  {
    common: 43,
    actual: 42.5,
    lengths:
      [
        {
          length: 64,
          price: 67.98,
          url: 'https://www.lowes.com/pd/LEVOLOR-Trim-Go-2-in-Cordless-White-Faux-Wood-Room-Darkening-Blinds-Common-43-in-Actual-42-5-in-x-64-in/1000576747'
        },
        {
          length: 48,
          price: 55.98,
          url: 'https://www.lowes.com/pd/LEVOLOR-Cut-to-42-5-in/1002832104'
        },
        {
          length: 72,
          price: 79.98,
          url: 'https://www.lowes.com/pd/LEVOLOR-Trim-Go-2-in-Cordless-White-Faux-Wood-Room-Darkening-Blinds-Common-43-in-Actual-42-5-in-x-72-in/1001461654'
        }
      ]
  },
  {
    common: 57,
    actual: 56.5,
    lengths:
      [
        {
          length: 64,
          price: 87.98,
          url: 'https://www.lowes.com/pd/LEVOLOR-Trim-Go-2-in-Cordless-White-Faux-Wood-Room-Darkening-Blinds-Common-57-in-Actual-56-5-in-x-64-in/1000576753'
        },
        {
          length: 48,
          price: 63.33,
          url: 'https://www.lowes.com/pd/LEVOLOR-LEV-2-IN-59X48-WHITE-FW-BLIND/1002838102'
        }
      ]
  },
  {
    common: 59,
    actual: 58.5,
    lengths:
      [
        {
          length: 48,
          price: 68.98,
          url: 'https://www.lowes.com/pd/LEVOLOR-Trim-Go-2-in-Cordless-White-Faux-Wood-Room-Darkening-Blinds-Common-59-in-Actual-58-5-in-x-48-in/1000576241'
        },
        {
          length: 64,
          price: 96.98,
          url: 'https://www.lowes.com/pd/LEVOLOR-Trim-Go-2-in-Cordless-White-Faux-Wood-Room-Darkening-Blinds-Common-59-in-Actual-58-5-in-x-64-in/1000576755'
        }
      ]
  },
  {
    common: 62,
    actual: 61.5,
    lengths:
      [
        {
          length: 64,
          price: 97.98,
          url: 'https://www.lowes.com/pd/LEVOLOR-Trim-Go-2-in-Cordless-White-Faux-Wood-Room-Darkening-Blinds-Common-62-in-Actual-61-5-in-x-64-in/1000576757'
        },
        {
          length: 72,
          price: 120.00,
          url: 'https://www.lowes.com/pd/LEVOLOR-Trim-Go-2-in-Cordless-White-Faux-Wood-Room-Darkening-Faux-Wood-Blinds-Common-61-5-in-Actual-61-5-in-x-72-in/1002830268'
        }
      ]
  },
  {
    common: 23,
    actual: 22.5,
    lengths:
      [
        {
          length: 64,
          price: 32.98,
          url: 'https://www.lowes.com/pd/LEVOLOR-Trim-Go-2-in-Cordless-White-Faux-Wood-Room-Darkening-Blinds-Common-23-in-Actual-22-5-in-x-64-in/1000575993'
        },
        {
          length: 72,
          price: 38.98,
          url: 'https://www.lowes.com/pd/LEVOLOR-Trim-Go-2-in-Cordless-White-Faux-Wood-Room-Darkening-Blinds-Common-23-in-Actual-22-5-in-x-72-in/1000576763'
        },
        {
          length: 48,
          price: 29.98,
          url: 'https://www.lowes.com/pd/LEVOLOR-Trim-Go-2-in-Cordless-White-Faux-Wood-Room-Darkening-Blinds-Common-23-in-Actual-22-5-in-x-48-in/1000576235'
        }
      ]
  },
  {
    common: 67,
    actual: 66.5,
    lengths:
      [
        {
          length: 64,
          price: 104.00,
          url: 'https://www.lowes.com/pd/LEVOLOR-Trim-Go-2-in-Cordless-White-Faux-Wood-Room-Darkening-Blinds-Common-67-in-Actual-66-5-in-x-64-in/1000576759'
        },
        {
          length: 72,
          price: 117.00,
          url: 'https://www.lowes.com/pd/LEVOLOR-LEV-2-IN-72X72-WHITE-FW-BLIND/1002832140'
        }
      ]
  },
  {
    common: 48,
    actual: 47.5,
    lengths:
      [
        {
          length: 64,
          price: 79.98,
          url: 'https://www.lowes.com/pd/LEVOLOR-Cut-to-47-5-in/1002829526'
        },
        {
          length: 72,
          price: 82.98,
          url: 'https://www.lowes.com/pd/LEVOLOR-Trim-Go-2-in-Cordless-White-Faux-Wood-Room-Darkening-Blinds-Common-48-in-Actual-47-5-in-x-72-in/1001461666'
        }
      ]
  },
  {
    common: 48,
    actual: 47.5,
    lengths:
      [
        {
          length: 64,
          price: 79.98,
          url: 'https://www.lowes.com/pd/LEVOLOR-Cut-to-47-5-in/1002829526'
        },
        {
          length: 72,
          price: 82.98,
          url: 'https://www.lowes.com/pd/LEVOLOR-Trim-Go-2-in-Cordless-White-Faux-Wood-Room-Darkening-Blinds-Common-48-in-Actual-47-5-in-x-72-in/1001461666'
        }
      ]
  },
  {
    common: 65,
    actual: 64.5,
    lengths:
      [
        {
          length: 64,
          price: 104.00,
          url: 'https://www.lowes.com/pd/LEVOLOR-Cut-to-64-5-in/1002829832'
        },
        {
          length: 72,
          price: 120.00,
          url: 'https://www.lowes.com/pd/LEVOLOR-Trim-Go-2-in-Cordless-White-Faux-Wood-Room-Darkening-Blinds-Common-65-in-Actual-64-5-in-x-72-in/1001461678'
        }
      ]
  },
  {
    common: 19,
    actual: 18.5,
    lengths:
      [
        {
          length: 64,
          price: 32.98,
          url: 'https://www.lowes.com/pd/LEVOLOR-Cut-to-18-5-in/1002782482'
        },
        {
          length: 48,
          price: 29.98,
          url: 'https://www.lowes.com/pd/LEVOLOR-Trim-Go-2-in-Cordless-White-Faux-Wood-Room-Darkening-Faux-Wood-Blinds-Common-18-5-in-Actual-18-5-in-x-48-in/1002830298'
        },
        {
          length: 72,
          price: 38.98,
          url: 'https://www.lowes.com/pd/LEVOLOR-Trim-Go-2-in-Cordless-White-Faux-Wood-Room-Darkening-Faux-Wood-Blinds-Common-18-5-in-Actual-18-5-in-x-72-in/1002829964'
        }
      ]
  },
  {
    common: 18,
    actual: 17.5,
    lengths:
      [
        {
          length: 64,
          price: 32.98,
          url: 'https://www.lowes.com/pd/LEVOLOR-Cut-to-17-5-in/1002825946'
        },
        {
          length: 48,
          price: 29.98,
          url: 'https://www.lowes.com/pd/LEVOLOR-Trim-Go-2-in-Cordless-White-Faux-Wood-Room-Darkening-Faux-Wood-Blinds-Common-17-5-in-Actual-17-5-in-x-48-in/1002830282'
        },
        {
          length: 72,
          price: 38.98,
          url: 'https://www.lowes.com/pd/LEVOLOR-Trim-Go-2-in-Cordless-White-Faux-Wood-Room-Darkening-Faux-Wood-Blinds-Common-17-5-in-Actual-17-5-in-x-72-in/1002829946'
        }
      ]
  },
]

export default { blinds, }